<script>
    import TheGuaranteeList from "@main/packages/TheGuaranteeList";
    import { GUARANTEE_BREAKPOINT } from "@miku-kz/settings/breakpoints";

    export default {
        name: "GuaranteeList",
        components: { TheGuaranteeList },
        data() {
            return {
                breakpoints: GUARANTEE_BREAKPOINT,
            };
        },
    };
</script>

<template>
    <the-guarantee-list
        :breakpoints="breakpoints"
        text-for-brand="MIKU"
        text-for-year=""
        :custom-text="{
            guarantee:
                '5&nbsp;лет на&nbsp;термосы и&nbsp;кружки,<br>1&nbsp;год на&nbsp;посуду для СВЧ',
            identity: 'Единственный официальный интернет-магазин MIKU в Республике Казахстан',
        }"
    ></the-guarantee-list>
</template>
